import React from 'react';

function FlipPage(props) {
    return <>{props.children}</>
}

export default FlipPage;